import { Injectable } from '@angular/core';
import { IClosedModalProps } from '@core/interfaces';
import { ModalController } from '@ionic/angular';
import { DialogComponent } from '@/shared/components/dialog/dialog.component';
import { I18nService } from '../i18n.service';
import { Store } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { selectLanguaje } from '@store/selectors';
import { ComponentEnum } from '@core/enums';
import { ILanguageObject } from '@core/interfaces';

@Injectable({
  providedIn: 'root'
})
export class DecisionModalService {
  translations: ILanguageObject;

  constructor(
    private modalCtrl: ModalController,
    private i18nService: I18nService,
    private store: Store<AppState>
  ){
    this.translations = this.i18nService.getTranslations(ComponentEnum.Notification);

    this.store.select(selectLanguaje).subscribe((languaje) => {
      this.translations = this.i18nService.getTranslations(ComponentEnum.Notification, languaje);
    });
  }

  async showClosedModal(props?: IClosedModalProps) {
    const topModal = await this.modalCtrl.getTop();
    if (topModal) {
      await this.modalCtrl.dismiss();
    }

    const title = this.translations[props?.title || 'storeClosedTitle'] || 'Store Closed';
    const message = props?.showLiteralTextQuestion
      ? props?.question
      : this.translations[props?.question || 'storeClosedMessage'] || "We're currently closed. Please come back later.";

    const modal = await this.modalCtrl.create({
      component: DialogComponent,
      componentProps: {
        title,
        message,
        type: 'warning',
        isStandaloneOverlay: false,
        showCloseIcon: false,
        showCancel: false,
        showFooter: props?.showOkBtn !== false || props?.secondBtn === true,
        showConfirm: props?.showOkBtn !== false,
        showThird: props?.secondBtn === true,
        confirmText: this.translations[props?.okText || 'Continue in Store'] || 'Continue in Store',
        thirdText: props?.secondBtn ? (this.translations[props?.secondBtnText || 'Close Store'] || 'Close Store') : undefined,
      },
      cssClass: 'modal-type-warning',
      backdropDismiss: false,
    });

    await modal.present();

    const { role } = await modal.onDidDismiss();

    if (role === 'confirm' && props?.okHandler) {
      props.okHandler();
    } else if (role === 'third' && props?.secondHandler) {
      props.secondHandler();
    } else if (role === 'cancel' && props?.cancelHandler) {
      props.cancelHandler();
    }
  }
}